import React from "react";

const Footer = () =>{
    return(
        <>
            <footer className="footer w-100 bg-secondary text-center">
                <p>Welcome to the @ S_TECHNOLOGY</p>
            </footer>
        </>
    )
}
export {Footer};